import { ICreateArticleDto } from "./Article"
import { Guid } from "@/types"
import ArticleService from "services/ArticleService"
import { ArticleMachineBase, IGetArticleMachineBaseDto } from "./ArticleMachineBase"

export interface IGetArticleMachineIntDto extends IGetArticleMachineBaseDto {

}

export interface IUpdateArticleMachineIntDto {
    inspectionRequired?: boolean
    sequence?: number | null
}

export interface ICreateArticleMachineIntDto extends Omit<ICreateArticleDto, "highLevelArticleNumber" | "lowLevelArticleNumbers" | "inspectionRequired"> {
    description: string
    productModelId: Guid
}

export class ArticleMachineInt extends ArticleMachineBase {
    static create(dto: ICreateArticleMachineIntDto) {
        return ArticleService.createArticle(dto)
    }

    #toUpdateDto(): IUpdateArticleMachineIntDto {
        return {
            inspectionRequired: this.inspectionRequired,
            sequence: this.sequence ?? null,
        }
    }

    async update() {
        if (!this.linkUpdate) {
            throw new Error("Update not allowed")
        }
        await ArticleService.updateArticle(this.linkUpdate, this.#toUpdateDto())
    }
}
